export const getPromoCodeInputs = (initialValues) => [
    {
      type: "TEXT",
      label: "Name",
      id: "name",
      name: "name",
      value: initialValues?.name || "",
      placeholder: "Enter the Name",
      validations: [
        {
          type: "REQUIRED",
          message: "Name is required !",
        },
      ],
    },
    {
      type: "TEXT",
      label: "Code",
      id: "code",
      name: "code",
      value: initialValues?.code || "",
      placeholder: "Enter the Code",
    },
    {
      type: "SELECT",
      label: "Type",
      id: "type",
      name: "type",
      options: [
        { name: "fixed", value: "1" },
        { name: "percentage", value: "2" },
      ],
      value: initialValues?.type || "1",
      placeholder: "Select Type",
    },
    {
      type: "TEXT",
      label: "Value",
      id: "code_value",
      name: "code_value",
      value: initialValues?.code_value || "",
      placeholder: "Enter the Value",
    },
    {
      type: "SELECT",
      label: "Status",
      id: "status",
      name: "status",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0" },
      ],
      value: initialValues?.status || "1",
      placeholder: "Select status",
    },
  ];
  